import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { InputGroup, Button, Form } from "react-bootstrap";
import "./CheckExist.css";
import { postData } from "../../../../utils/api";
import ModalSave from "../../ModalSave";
import ForgetPasswordModal from "../../modal/forgetPasswordModal/ForgetPasswordModal";

const CheckExist = ({ show, onHide }) => {
  const [formData, setFormData] = useState({
    email: "",
  });

  const [showForgetModal, setShowForgetModal] = useState(false);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.email) {
      newErrors.email = "Email is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await postData("/check-exist", formData);


      if (response.success) {
        setShowForgetModal(true);
      } else {
        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          setShowModal(false);
          // onHide();
        }, 2000);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Send OTP</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>

            <InputGroup>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          <div className="text-end">
            <Button variant="secondary" className="me-2" onClick={onHide}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Check Exist
            </Button>
          </div>
        </Form>
      </Modal.Body>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <ForgetPasswordModal
        show={showForgetModal}
        onHide={() => {
          setShowForgetModal(false);
        }}
      />
    </Modal>
  );
};

export default CheckExist;
